import { render } from "./Beneficiarios.vue?vue&type=template&id=486b6484&scoped=true"
import script from "./Beneficiarios.vue?vue&type=script&lang=js"
export * from "./Beneficiarios.vue?vue&type=script&lang=js"

import "./Beneficiarios.vue?vue&type=style&index=0&id=486b6484&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486b6484"]])

export default __exports__